import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { stateListData, cityList } from "@/api/bid";
import { Modal, Button, Form } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
// import ValidateLicenceModel from "./ValidateLicenceModel";
import InputGroup from 'react-bootstrap/InputGroup';
import {
    getAdditionalInfo,
    verifyLicenseDetails,
    fetchAccessCode,
} from '@/api/AccessCode';

import '/src/components/pdp/style/pdp.css'
import { validateForm } from "@/utils/formValidator";
import { saveBuyerProfileForNDA, acceptNDA } from "@/api/PDP"
import {
    fetchPDPInitialLoad,
} from "@/redux/PDP/pdpSlice";
import LoadingText from "@/components/loader/LoadingText.jsx";
import LoadedText from "@/components/loader/LoadedText.jsx";
import { getCommercialWatchProperty } from "@/api/bidDepositApiHold";

import { setIsNDAAccepted } from "@/redux/PDP/pdpSlice";
import { trackApiCall, trackButtonClick } from "@/utils/analytics";

function NDAModel({
    show,
    userProfileData,
    handleClose,
    handleNDAccept,
    isFormDocuments,

}) {

    const [errors, setErrors] = useState({});
    const [userData, setUserData] = useState(userProfileData);
    const pdpInitData = useSelector((state) => state.pdp.pdpInitData)
    let formRef = useRef();
    const [validated, setValidated] = useState(false);
    const [isProccessing, setIsProccesing] = useState(false);
    const dispatch = useDispatch();



    const [citySuggestions, setCitySuggestions] = useState([]);

    const [allCities, setAllCities] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [showAgreement, setShowAgreement] = useState(false);
    const [tncAccepted, setTnCAccepted] = useState(false);
    const [tncAcceptedTapped, setTnCAcceptedTapped] = useState(false);



    const propertyId = pdpInitData?.propertyDetails?.propertyId;
    const { user } = useSelector((state) => state?.user);





    const [stateList, setStatelist] = useState([]);

    const [formData, setFormData] = useState({

        address: user?.address1 || "",
        state: user?.state || "",
        city: user.city || "",
        zip: user.zip || "",
        company: '',
    });

    useEffect(() => {
        stateListData().then((res) => {
            setStatelist(res.data);
        });
    }, []);

    useEffect(() => {

        setFormData((prev) => ({
            address: user?.address1 || "",
            state: user?.state || "",
            city: user.city || "",
            zip: user.zip || "",
            company: '',
        }));




    }, [user]);




    const validationRules = {
        name: (value) => {
            if (!value?.trim()) return "This field is required";
            const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
            if (value && !allowedCharsRegex.test(value)) {
                return "Characters allowed: a-z A-Z 0-9 and - . ' _";
            }
            return "";
        },
        email: (value) => {
            if (!value) return "This field is required";
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                return "Please enter a valid email address";
            }
            return "";
        },
        company: (value) => {
            if (!value?.trim()) return "This field is required";
            const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
            if (value && !allowedCharsRegex.test(value)) {
                return "Characters allowed: a-z A-Z 0-9 and - . ' _";
            }
            return "";
        },
        phone: (value) => {
            if (!value) return "This field is required";
            if (!/^\d{10}$/.test(value)) return "Please enter a valid phone number";
            return "";
        },
        address: (value) => {
            if (!value?.trim()) return "This field is required";
            const allowedCharsRegex = /^[a-zA-Z0-9#(),.'\s]*$/;
            if (value && !allowedCharsRegex.test(value)) {
                return "Characters allowed: a-z A-Z 0-9 and - . ' _ #";
            }
            return "";
        },
        address2: (value) => {
            // if (!value?.trim()) return "This field is required";
            const allowedCharsRegex = /^[a-zA-Z0-9#(),.'\s]*$/;
            if (value && !allowedCharsRegex.test(value)) {
                return "Characters allowed: a-z A-Z 0-9 and - . ' _#";
            }
            return "";
        },
        city: (value) => {
            if (!value?.trim()) return "This field is required";
            const allowedCharsRegex = /^[a-zA-Z0-9\-._' ]*$/;
            if (value && !allowedCharsRegex.test(value)) {
                return "Characters allowed: a-z A-Z 0-9 and - . ' _";
            }
            return "";
        },
        state: (value) => {
            if (!value) return "This field is required";
            return "";
        },
        zip: (value) => {
            if (!value) return "This field is required";
            if (!/^\d{5}$/.test(value))
                return "Please enter a valid 5-digit ZIP code";
            return "";
        },

    };




    const handleSuggestionClick = (suggestion) => {

        setFormData((prev) => ({
            ...prev,
            city: suggestion,
        }));

        setCitySuggestions([]);
        setShowSuggestions(false);
    };


    const handleSubmit = (event) => {
        setIsProccesing(true);
        const form = formRef.current;

        event.preventDefault();
        event.stopPropagation();



        const isValid = form?.checkValidity();


        for (const [key, value] of Object.entries(formData)) {

            const validationError = validationRules[key](value);
            setErrors((prev) => ({
                ...prev,
                [key]: validationError,
            }));

        }




        const hasAnyValue = Object.values(errors).some(value => value.trim() !== "");




        if (!hasAnyValue && isValid) {


            setValidated(true);


            const payload = {
                userDetails: {
                    firstName: userProfileData?.userFirstName,
                    lastName: userProfileData?.userLastName,
                    emailId: userProfileData?.userEmailId,
                    address: {
                        address1: formData.address,
                        address2: "",
                        state: formData.state,
                        city: formData.city,
                        cityFromDropDown: false,
                        zip: formData.zip
                    },
                    companyName: formData.company,
                    phoneNumber: userProfileData.primaryPhone
                }
            };



            saveBuyerProfileForNDA(payload).then((response) => {
                if (response.status === "SUCCESS") {
                    setIsProccesing(false);
                    setShowAgreement(true);
                } else {
                    if (response.errorMessage === "VALIDATION_STATE_ZIP_FAILURE") {
                        setErrors((prev) => ({
                            ...prev,
                            ['zip']: "Provided zip code is not valid for selected state",
                        }));

                    }
                }

            });



        } else {
            setIsProccesing(false);
        }



    };


    const handleInputChange = (e) => {
        const { id, value } = e.target;
        // Check if this is the phone field

        let processedValue = value;
        if (id === "phone" || id === "phoneNumber" || id === "zip") {
            // Remove all alphabet characters
            processedValue = value.replace(/[a-zA-Z]/g, "");
        }

        if (id === "city" && value.length > 2) {


            const filteredCities = allCities.filter((city) =>
                city.toLowerCase().includes(value.toLowerCase())
            );
            setCitySuggestions(filteredCities);
            setShowSuggestions(true);
        } else if (id === "city") {
            setCitySuggestions([]);
            setShowSuggestions(false);
        }

        setFormData((prevData) => ({
            ...prevData,
            [id]: processedValue,
        }));


    };

    const handleBlur = (e) => {
        const { id, value } = e.target;

        if (validationRules[id]) {
            const validationError = validationRules[id](value);


            setErrors((prev) => ({
                ...prev,
                [id]: validationError,
            }));


        }
    }

    const fetchCities = async (stateId) => {
        try {
            const response = await cityList(stateId);
            setAllCities(response?.data?.data || []);
            setCitySuggestions([]);
            setShowSuggestions(false);
        } catch (error) {
            setAllCities([]);
        }
    };

    useEffect(() => {
        if (formData.state) {
            fetchCities(formData.state);
        }
    }, [formData.state]);


    const getFormatPrice = amount => {
        if (amount?.length === 0 || amount === null || isNaN(amount)) {
            return '';
        }
        return amount?.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    };

    const handleCheckboxChange = (e) => {

        setTnCAccepted(e.target.checked)
        setTnCAcceptedTapped(true);
    }

    const handleAccept = () => {

        if (tncAccepted) {
            trackButtonClick({
                eventName: "sign_nda_confidentiality_agreement",
                eventCategory: "NEW-PDP",
                eventSource: "on confidentiality agreement click",
                eventLabel: `PropertyId: ${propertyId}`
            })
            setIsProccesing(true);
            acceptNDA(propertyId, userProfileData?.realbidUserId).then(res => {
                if (res.status === 'SUCCESS') {
                    trackApiCall({
                        eventName: "nda_agreement_accept_success",
                        eventCategory: "NEW-PDP",
                        eventSource: "on confidentiality agreement success",
                        eventLabel: `PropertyId: ${propertyId}`
                    })
                    dispatch(setIsNDAAccepted('Y'));
                    getCommercialWatchProperty(propertyId).then(res => {
                        setIsProccesing(false);
                        // dispatch(fetchPDPInitialLoad(propertyId));
                        handleNDAccept()
                    })

                    // handleClose();
                }
            });
        } else {
            setTnCAcceptedTapped(true);
        }


    }
    function formatUSPhoneNumber(phone) {
        // Remove all non-digit characters
        const digits = phone?.replace(/\D/g, '');

        if (digits?.length === 10) {
            return `(${digits?.slice(0, 3)}) ${digits?.slice(3, 6)}-${digits?.slice(6)}`;
        } else if (digits?.length === 11 && digits?.startsWith('1')) {
            return `+1 (${digits?.slice(1, 4)}) ${digits?.slice(4, 7)}-${digits?.slice(7)}`;
        } else {
            return 'Invalid phone number';
        }
    }


    return (
        <div className=""  >

            <Modal show={show} size="lg" onHide={handleClose} id="ndapopmodal">
                <Modal.Header closeButton>
                    <Modal.Title style={{ color: '#2A69A3' }}>{showAgreement ? "Confidentiality Agreement" : "Profile Information"} </Modal.Title>
                </Modal.Header>

                {
                    showAgreement ?
                        <Modal.Body>
                            <p className="NDA-text pt10 pl30">To view available documents and register to bid, you must review and agree to the Confidentiality Agreement.
                                {/* <a className="link-primary" href="https://image-prod.hubzu.com/sampledocs/CONFIDENTIALITY_AGREEMENT_pre-agreement.pdf"> Confidentiality Agreement</a>
                                . */}

                            </p>
                            <Row className="pt10 pl30">
                                <Form.Group controlId="" className="my-md-0 my-3">
                                    <Form.Check
                                        type="checkbox"
                                        id="defaultCheck2"
                                        className="NDA-checkbox NDA-text"
                                        onChange={handleCheckboxChange}
                                        label={
                                            <>
                                                I have read and agree to Hubzu's {" "}
                                                <a className="link-primary" target="_blank" href="https://image-prod.hubzu.com/sampledocs/CONFIDENTIALITY_AGREEMENT_pre-agreement.pdf">Confidentiality Agreement</a>
                                            </>
                                        }

                                    />
                                    {(!tncAccepted && tncAcceptedTapped) && (
                                        <p className="error-generic pl30">{"Please acknowledge the agreement by checking the box."}</p>
                                    )}
                                </Form.Group>
                            </Row>
                            <div className="row d-flex justify-content-center align-content-center p10">
                                <button className="btn hubzu-btn-thm center w-90 h50" type=""
                                    onClick={handleAccept}>

                                    {
                                        isProccessing ? <LoadingText text="I Agree..." /> : <LoadedText text="I Agree" />
                                    }
                                </button>
                            </div>

                        </Modal.Body>

                        :
                        <Modal.Body>
                            <p className="NDA-text pt10 pl30 ">Please complete the following profile information to proceed.</p>

                            <Row className="pt10 pl30">
                                <Col xs={12} md={12}>
                                    <p className="mb-3">
                                        {/* <strong>Closing Agent: </strong> */}
                                        <Row className="row pt10 bold">
                                            <Col xs={12} md={3} className="NDA-text-bold ">Your Name:</Col>
                                            <Col xs={12} md={6} className="NDA-text ">{userProfileData?.userFirstName + " " + userProfileData?.userLastName}</Col>
                                        </Row>
                                        <Row className="row pt10 bold">
                                            <Col xs={12} md={3} className="NDA-text-bold ">Your Email:</Col>
                                            <Col xs={12} md={2} className="NDA-text ">{userProfileData?.userEmailId}</Col>
                                        </Row>
                                        <Row className="row pt10 bold">
                                            <Col xs={12} md={3} className="NDA-text-bold ">Your Phone Number:</Col>
                                            <Col xs={12} md={4} className="NDA-text ">{formatUSPhoneNumber(userProfileData?.primaryPhone)}</Col>
                                        </Row>
                                        {/* <p className="NDA-text">Email:{userProfileData?.userEmailId} </p>
                                        <p className="NDA-text">Phone Number:{userProfileData?.primaryPhone} </p> */}

                                    </p>

                                </Col>

                            </Row>

                            <form className="p20 pl25" ref={formRef} noValidate validated={validated} onSubmit={handleSubmit}>



                                <div className="col-md-12 mb-3">
                                    <Form.Group controlId="address" className="my-md-0 my-3">

                                        <Form.Label className="NDA-text">Address</Form.Label>
                                        <span className="NDA-text" style={{ color: "#d13b3b" }}>
                                            *
                                        </span>

                                        <Form.Control
                                            required
                                            className="NDA-text-input"
                                            type="text"
                                            placeholder="Address"
                                            value={formData.address}
                                            onChange={handleInputChange}
                                            onBlur={handleBlur}
                                            pattern="/^[a-zA-Z0-9#(),'\s]*$/"
                                            maxLength={70}
                                            isInvalid={!!errors.address} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.address}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <Row>
                                    <div className="col-md-4 mb-3">
                                        <Form.Group controlId="state" className="my-md-0 my-3">
                                            <Form.Label className="NDA-text">State</Form.Label>
                                            <span className="NDA-text" style={{ color: "#d13b3b" }}>
                                                *
                                            </span>
                                            <Form.Select
                                                required
                                                className=" h50 form-select NDA-state-dropdown"
                                                value={formData.state}
                                                onChange={handleInputChange}
                                                placeholder="State"

                                                onBlur={handleBlur}
                                                isInvalid={!!errors.state}
                                            >
                                                <option value="">Select State</option>
                                                {stateList.length > 0 &&
                                                    stateList?.map((state) => (
                                                        <option key={state} value={state}>
                                                            {state}
                                                        </option>
                                                    ))}
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid">
                                                {errors.state || "Please select a state."}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <Form.Group controlId="city" className="my-md-0 my-3">
                                            <Form.Label className="NDA-text">City</Form.Label>
                                            <span className="NDA-text" style={{ color: "#d13b3b" }}>
                                                *
                                            </span>
                                            <Form.Control
                                                required
                                                className="NDA-text-input"
                                                type="text"
                                                placeholder="City"
                                                value={formData.city}
                                                onChange={handleInputChange}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.city} />
                                            {showSuggestions &&
                                                citySuggestions.length > 0 && (
                                                    <div className="suggestions-container">
                                                        {citySuggestions.map(
                                                            (suggestion, index) => (
                                                                <div
                                                                    key={index}
                                                                    className="suggestion-item"
                                                                    onClick={() => handleSuggestionClick(suggestion)}
                                                                >
                                                                    {suggestion}
                                                                </div>
                                                            )
                                                        )}
                                                    </div>
                                                )}
                                            <Form.Control.Feedback type="invalid">
                                                {errors.city || "Please enter a city."}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <Form.Group controlId="zip" className="my-md-0 my-3">
                                            <Form.Label className="NDA-text">Zip</Form.Label>
                                            <span className="NDA-text" style={{ color: "#d13b3b" }}>
                                                *
                                            </span>
                                            <Form.Control
                                                required
                                                className="NDA-text-input"
                                                type="text"
                                                placeholder="Zip"
                                                value={formData.zip}
                                                onChange={handleInputChange}
                                                onBlur={handleBlur}
                                                maxLength={5}
                                                isInvalid={!!errors.zip} />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.zip ||
                                                    "Please enter a valid 5-digit zip code."}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                </Row>
                                <div className="col-md-12 mb-3">
                                    <Form.Group controlId="company" className="my-md-0 my-3">
                                        <Form.Label className="NDA-text">Company Name</Form.Label>
                                        <span className="NDA-text" style={{ color: "#d13b3b" }}>
                                            *
                                        </span>

                                        <Form.Control
                                            required
                                            className="NDA-text-input"
                                            type="text"
                                            placeholder="Company Name"
                                            value={formData.company}
                                            onChange={handleInputChange}
                                            onBlur={handleBlur}
                                            maxLength={70}
                                            isInvalid={!!errors.company} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.company || "This field is required"}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div className="row d-flex justify-content-center align-content-center p10">
                                    <button className="btn hubzu-btn-thm center w-90 h50" type=""
                                        onClick={handleSubmit}>
                                        {
                                            isProccessing ? <LoadingText text="Continue..." /> : <LoadedText text="Continue" />
                                        }

                                    </button>
                                </div>
                            </form>
                        </Modal.Body>
                }


            </Modal >


        </div >

    );

}

export default NDAModel;
